export default "__VITE_ASSET__Lei2Jerm__"